import React, { useState } from "react";
import {
  Row,
  Col,
  Button,
  Dropdown,
  Modal,
  Form,
  Breadcrumb,
} from "react-bootstrap";
import { FiHome, FiUpload, FiPlus, FiChevronUp } from "react-icons/fi";

// import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import ChatApplication from "../../components/Applications/chat/ChatApplication";
import { RiHome6Line } from "react-icons/ri";

const ChatsPage = ({ openModal }) => {
  return (
    <div style={{ padding: "15px", background: "#f8f9fa", height: "100vh" }}>
      <Row className="align-items-center justify-content-between ">
        {/* <Col md={6}>
          <h3 className="mb-1 fw-bold">Escalation Rules</h3>

          <div className="d-flex align-items-center text-muted">
            <FiHome size={16} />
            <span className="mx-2">Tickets</span>
            <span>Escalation Rules</span>
          </div>
        </Col> */}
        <Col md={6} sm={12}>
          <div className="my-auto mb-2">
            <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Chat</h4>

            <Breadcrumb
              style={{
                background: "transparent",
                padding: 0,
                margin: 0,
                fontSize: "14px",
              }}
            >
              <Breadcrumb.Item>
                <RiHome6Line
                  className="m text-dark"
                  style={{
                    fontSize: "1.2rem", // increased icon size
                    verticalAlign: "middle",
                   
                  }}
                />
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item
                linkAs="span"
                className="text-dark text-decoration-none fs-6"
              >
                Application
              </Breadcrumb.Item>

              <MdKeyboardArrowRight className="mt-1 fs-5" />

              <Breadcrumb.Item active>
                <span className="text-dark fs-6">Chat</span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </Col>
      </Row>

      <ChatApplication />
    </div>
  );
};

export default ChatsPage;
